import { Link, useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, ClipboardList, Users, LogOut, Plus, Mail } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const isAdmin = user?.role === "admin";

  const nav = isAdmin
    ? [
        { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard },
        { to: "/admin/transports", label: "Transports", icon: ClipboardList },
        { to: "/admin/chauffeurs", label: "Chauffeurs", icon: Users },
        { to: "/admin/envois", label: "Journal courriels", icon: Mail },
      ]
    : [
        { to: "/chauffeur", label: "Mes transports", icon: ClipboardList },
        { to: "/chauffeur/nouveau", label: "Nouveau", icon: Plus },
      ];

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col md:flex-row">
      {/* Sidebar */}
      <aside className="md:w-64 md:min-h-screen border-b md:border-b-0 md:border-r-2 border-border bg-card md:sticky md:top-0">
        <div className="p-4 border-b-2 border-border">
          <img src="/brand/logo-mark.png" alt="TransPrestige" className="block h-20 w-auto" />
          <div className="label-caps text-muted-foreground mt-1">{isAdmin ? "Console admin" : "Espace chauffeur"}</div>
        </div>
        <nav className="p-3 flex md:flex-col gap-1 overflow-x-auto">
          {nav.map((n) => {
            const Icon = n.icon;
            const active = location.pathname === n.to;
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.to.replaceAll("/", "-")}`}
                className={`flex items-center gap-3 px-4 py-3 text-sm font-semibold border-2 transition-colors ${
                  active
                    ? "bg-primary text-primary-foreground border-primary"
                    : "border-transparent hover:border-border hover:bg-secondary"
                }`}
              >
                <Icon className="w-4 h-4" />
                <span>{n.label}</span>
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t-2 border-border mt-auto hidden md:block">
          <div className="text-xs text-muted-foreground mb-2 truncate">{user?.email}</div>
          <Button
            data-testid="logout-btn"
            variant="outline"
            size="sm"
            className="w-full rounded-none border-2"
            onClick={async () => { await logout(); navigate("/login"); }}
          >
            <LogOut className="w-4 h-4 mr-2" /> Déconnexion
          </Button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">{children}</main>
    </div>
  );
}
